import { Component, OnInit , signal} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'kt-handover-notes-acknowledged-list',
  templateUrl: './handover-notes-acknowledged-list.component.html',
  styleUrls: ['./handover-notes-acknowledged-list.component.scss']
})
export class HandoverNotesAcknowledgedListComponent implements OnInit {

  loading = signal(false);
  acknowledgedByList;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

}
